import { render } from "./RenderedProductLabel.vue?vue&type=template&id=bc78400a&ts=true"
import script from "./RenderedProductLabel.vue?vue&type=script&lang=ts"
export * from "./RenderedProductLabel.vue?vue&type=script&lang=ts"

import "./RenderedProductLabel.vue?vue&type=style&index=0&id=bc78400a&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__